import { captureException } from '@sentry/nextjs'

import { CreditCardAlternativeProductsCategory } from '@appTypes/EligibilityApi.interface'

import { useUnscoredAlternativeProductsQuery } from '@queries/useUnscoredAlternativeProductsQuery'

import AnimatedLoadingPage from '@components/AnimatedLoadingPage'
import ErrorBoundary from '@components/ErrorBoundary'
import MetadataHead from '@components/MetadataHead'

import AlternativeProductsTableError from '../AlternativeProductsTableRoute/components/AlternativeProductsTableError'
import UnscoredAlternativeProductsTable from './components/UnscoredAlternativeProductsTable'

const UnscoredAlternativeProductsTableRoute = () => {
    const alternativeProductsResponse = useUnscoredAlternativeProductsQuery({})

    switch (true) {
        case alternativeProductsResponse.isInitialLoading:
            return <AnimatedLoadingPage />
        case alternativeProductsResponse.isSuccess &&
            alternativeProductsResponse.data != null:
            return (
                <>
                    <MetadataHead metadata={undefined} />
                    <ErrorBoundary
                        fallback={<AlternativeProductsTableError />}
                        onError={({ error }) => captureException(error)}
                    >
                        <UnscoredAlternativeProductsTable
                            alternativeProductCategories={
                                alternativeProductsResponse.data as CreditCardAlternativeProductsCategory[]
                            }
                        />
                    </ErrorBoundary>
                </>
            )
        case alternativeProductsResponse.isError:
        default:
            return <AlternativeProductsTableError />
    }
}

export default UnscoredAlternativeProductsTableRoute
